 
// Interface for setJourney
export interface SetJourneyParams {
  Journey: {
    Name: string;
    Version: string;
  };
  Brand: string;
  Division: string;
  Presentation: string;
  Product: {
    Location1: string;
    Location2: string;
  };
  Channel: {
    Location: string;
    SortCode: string;
    FileId: string;
    CustomerAuth: boolean;
  };
  PageRole: string;
  JourneyProduct: {
    Product1: string;
    Product2: string;
    Product3: string;
  };
  ApplicationId: string;
}

// Interface for setPageLoadEvent
export interface PageLoadEventParams {
  JourneyStepName: string;
  JourneyAction: string;
  JourneyActionNarrative: string;
  JourneyProduct: string;
  JourneyStep: string;
  ApplicationState: string;
}

// Interface for sendButtonEvent
export interface SendButtonEventParams {
  JourneyEvent: string;
  LinkValue: string;
}

const runAnalytics = (callback): void => {
  try {
    (window as any)?.runAnalytics?.(callback);
  } catch (error) {
    console.error(error);
  }
};

export const setJourney = ({
  Journey,
  Brand,
  Division,
  Presentation,
  Product,
  Channel,
  PageRole,
  JourneyProduct,
  ApplicationId,
}: SetJourneyParams): void => {
  try {
    runAnalytics((LBGAnalytics) => {
      LBGAnalytics.data
        .setJourney(Journey.Name, Journey.Version)
        .setBrand(Brand)
        .setDivision(Division)
        .setPresentation(Presentation)
        .setProduct(Product.Location1, Product.Location2)
        .setChannel(
          Channel.Location,
          Channel.SortCode, // sortcode of the processing location
          Channel.FileId, // file ID of the processing  colleague
          Channel.CustomerAuth, // is the customer authenticated?
        )
        .setPageRole(PageRole)
        .setJourneyProduct(
          JourneyProduct.Product1,
          JourneyProduct.Product2,
          JourneyProduct.Product3,
        )
        .setApplicationId(ApplicationId);
    });
  } catch (error) {
    console.log(`setJourney for ${Journey.Name} analytics error: ${error}`);
  }
};

// Sends setJourneyStep and setJourneyStatus event with given details
export const setPageLoadEvent = ({
  JourneyStepName,
  JourneyAction,
  JourneyActionNarrative,
  JourneyProduct,
  JourneyStep,
  ApplicationState,
}: PageLoadEventParams): void => {
  try {
    runAnalytics((LBGAnalytics) => {
      LBGAnalytics.data
        .setJourneyStep(JourneyStep, JourneyStepName)
        .setJourneyStatus(
          JourneyAction,
          JourneyActionNarrative,
          ApplicationState,
        )
        .setJourneyProduct(JourneyProduct, undefined, undefined)
        .done()
        .events.pageView()
        .send();
    });
  } catch (error) {
    console.log('setPageLoadEvent analytics error: ', error);
  }
};

// Sends field update events
export const sendFieldUpdateEvent = (
  fieldName: string,
  dwellInMS?: number,
): void => {
  try {
    (window as any).LBGAnalytics?.events
      ?.fieldUpdate(fieldName, dwellInMS)
      ?.send();
  } catch (error) {
    console.log('sendTooltipEvent analytics error: ', error);
  }
};

// Sends button events
export const sendButtonEvent = (event: SendButtonEventParams): void => {
  try {
    (window as any).LBGAnalytics?.events?.send({ ...event });
  } catch (error) {
    console.log('sendButtonEvent analytics error: ', error);
  }
};

// Sends event
export const sendEvent = (event: any): void => {
  try {
    (window as any).LBGAnalytics?.events?.send({ ...event });
  } catch (error) {
    console.log('sendEvent error: ', error);
  }
};

// sends accordion events
export const sendAccordionEvent = (
  JourneyEvent: string,
  EventAction: string,
): void => {
  try {
    (window as any)?.LBGAnalytics?.events
      ?.accordion(JourneyEvent, EventAction)
      ?.send();
  } catch (error) {
    console.log('sendAccordionEvent analytics error: ', error);
  }
};
